<template>
  <div>
    <base-layout :menu-items="menuItems">
      <template slot="content">
        <!-- Loader -->
        <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="getIsLoading">
          <gd-loader :label="$t('frontend_loading')" />
        </div>

        <!-- target for other loders -->
        <portal-target name="loaderTarget"></portal-target>

        <!-- target for modals -->
        <portal-target name="modalsTarget"></portal-target>

        <div id="" class="w-full h-full flex">
          <div class="flex flex-col w-full h-full">

            <transition :name="bannerTransition">
              <div v-if="isBlocked && showBlockBanner" class="w-full bg-primary-dark text-primary-invert p-2 mb-2 row">
                <div class="flex text-sm justify-between">
                  <span>
                    <i class="fa fa-info-circle"></i>
                    <span class="ml-2">{{
                      $t('frontend_groovemail_banner_blocked_user')
                      }}</span>
                  </span>
                  <span class="cursor-pointer" @click="closeBlockedBanner()">
                    <i class="fas fa-times"></i>
                  </span>
                </div>
              </div>
              <div v-else-if="isSmtpBlocked && showSMTPBanner && isSmtpBannerShown"
                class="w-full bg-yellow-dark text-black p-2 mb-2 row">
                <div class="flex text-sm justify-between">
                  <span>
                    <i class="fa fa-info-circle"></i>
                    <span class="ml-2">{{
                      $t('frontend_groovemail_banner_blocked_smtp_user')
                      }}</span>
                  </span>
                  <span class="cursor-pointer" @click="closeSMTPBanner()">
                    <i class="fas fa-times"></i>
                  </span>
                </div>
              </div>
            </transition>

            <transition :name="bannerTransition">
              <div v-if="limitExceeded && showLimitBanner"
                class="w-full bg-primary-dark text-primary-invert p-2 mb-2 row">
                <div class="flex text-sm justify-between">
                  <span>
                    <i class="fa fa-info-circle"></i>
                    <span class="ml-2">{{ limitExceeded }}</span>
                  </span>
                  <span class="cursor-pointer" @click="closeLimitExceedBanner()">
                    <i class="fas fa-times"></i>
                  </span>
                </div>
              </div>
            </transition>
            <VuePerfectScrollbar class="w-full h-full" :settings="scrollbarSettings">
              <div class="">
                <transition :name="routerTransition">
                  <router-view></router-view>
                </transition>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>
      </template>
      <template slot="header-bar">
        <header-bar v-if="$route.meta.breadcrumb || $route.meta.pageTitle" :route-title="$t(routeTitle)" />
        <ImportProgressBar ref="importMsg" />
      </template>
      <template slot="sidebar">
        <sidebar-menu></sidebar-menu>
      </template>
    </base-layout>
    <!-- Can mail/Upgraded user/Sandbox mode check -->
    <gd-modal id="show-sandbox-message-modal" name="show-sandbox-message-modal" class="p-2"
      :title="$t('frontend_groovemail_beta_mode')">
      <div class="pt-5 pb-8 px-8 text-justify text-grey-700">
        <p>{{ $t('frontend_groovemail_beta_mode_info_message_part_1') }}</p>
        <br>
        <p>{{ $t('frontend_groovemail_beta_mode_info_message_part_2') }}
          <span class="font-bold uppercase">{{ $t('frontend_groovemail_beta_mode_info_message_upgrade_now') }}</span>
        </p>
      </div>
    </gd-modal>
    <!-- Can mail/Upgraded user/Sandbox mode check -->
  </div>
</template>

<script>
import BaseLayout from '../design-system/account-adapter';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import store from '@/state';
import ImportProgressBar from '@/components/ImportProcessBar';

export default {
  components: {
    BaseLayout,
    VuePerfectScrollbar,
    ImportProgressBar
  },
  data() {
    return {
      limitExceeded: '',
      isBlocked: 0,
      isSmtpBlocked: 0,
      isSmtpBannerShown: 0,
      showLimitBanner: true,
      showBlockBanner: true,
      showSMTPBanner: true,
      bannerTransition: 'fade',
      isExternal: true,
      showSlider: false,
      routerTransition: 'zoom-fade',
      routeTitle: this.$route.meta.pageTitle,
      isAdmin: null,
      scrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },

  computed: {
    ...mapGetters('loader', ['getIsLoading']),

    menuItems() {
      return [];
    },

    userCanMail() {
      return this.getCanMail();
    },
  },

  watch: {
    async $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },

  async created() {
    this.isAdmin = store.state.user.admin;
    const dashboardData = await axios.get('/dashboard');
    this.limitExceeded = dashboardData.data.exeed
      ? dashboardData.data.exeed
      : 0;
    this.isBlocked = dashboardData.data.is_blocked;
    this.isSmtpBlocked = dashboardData.data.groovemail_smtp_enable === 0;
    this.isSmtpBannerShown = dashboardData.data.smtp_alert_show === 1;
    this.SET_CAN_MAIL(dashboardData.data.can_mail);
    this.SET_CAN_IMPORT_LEADS(dashboardData.data.can_import);
    this.SET_CAN_ACCESS_INTERNAL_SMTP(dashboardData.data.groovemail_smtp_enable);
    if (!this.isAdmin && this.$route.fullPath.includes('/admin')) {
      this.$router.push({ name: 'dashboard' });
    }
  },

  methods: {
    ...mapGetters('mailing', ['getCanMail']),
    ...mapMutations('mailing', ['SET_CAN_MAIL', 'SET_CAN_IMPORT_LEADS', 'SET_CAN_ACCESS_INTERNAL_SMTP']),

    // Can mail/Upgraded user/Sandbox mode check
    showSandboxModeMessage() {
      this.$root.$emit('modal-open', 'show-sandbox-message-modal');
    },
    // Can mail/Upgraded user/Sandbox mode check

    closeLimitExceedBanner() {
      this.showLimitBanner = false;
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    closeBlockedBanner() {
      this.showBlockBanner = false;
    },
    closeSMTPBanner() {
      axios
        .post('/disable-smtp-banner')
        .then((response) => {
          this.showSMTPBanner = false;
        })
        .catch((error) => {
          this.showSMTPBanner = true;
        });

    },
  },
};
</script>

<style scoped>
#groovesellCont {
  height: calc(100vh - 4rem) !important;
}
</style>
